module.exports = __webpack_public_path__ + "img/lets-check-logo.b06a867a.svg";